import { useState } from "react";
import PageHeading from "../../PageHeading";
import EmergencyAgentList from "./EmergencyAgent/EmergencyAgentList";
import EmergencyServiceList from "./EmergencyServiceList/EmergencyServiceList";


const EmergencyConfig = () => {
  const [activeTab, setActiveTab] = useState("Agent");

  const tabs = [
    {
      name: "Agent",
      content: (
        <div className="tab-content">
          <EmergencyAgentList />
        </div>
      ),
    },
    {
      name: "Service List",
      content: (
        <div className="tab-content">
          <EmergencyServiceList />
        </div>
      ),
    },
  ];

  const breadcrumbs = [
    { label: "Dashboard", url: "/" },
    { label: "Emergency" },
    { label: "Emergency Config" },
  ];

  return (
    <div>
      <div className="print-hidden">
        <PageHeading title="Emergency Configuration" breadcrumbs={breadcrumbs} />
      </div>
      <div className="emergency-container flex flex-col xl:flex-row gap-5 items-start">
        {/* Left-side tabs */}
        <div className="tab-list flex w-full flex-col sm:flex-row xl:flex-col xl:w-64 shrink-0 bg-white border-r border-gray-200 shadow-sm rounded-lg overflow-hidden">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`tab-button w-full text-center xl:text-left py-3 px-2 xl:px-4 text-xs xl:text-sm font-medium text-gray-700 border-b border-gray-200 transition-colors duration-200 ${
                activeTab === tab.name
                  ? "bg-gray-100 text-blue-600 font-semibold"
                  : "hover:bg-gray-50"
              }`}
              onClick={() => setActiveTab(tab.name)}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {/* Right-side content */}
        <div className="content-area flex-grow w-full">
          {tabs.find((tab) => tab.name === activeTab)?.content}
        </div>
      </div>
    </div>
  );
};

export default EmergencyConfig;